export default {
  image: 'A4_10.png',
  pdf: '220922_WA-MIWO_011_A4_10_Rev02_ar.pdf',
  productData: {
    serialNumber: 'WA-MIWO-011',
    technicalValues: {
      soundReductionIndex: {
        output: '53,1',
        value: 53.1
      },
      heatTransferCoefficient: {
        output: '0,19',
        value: 0.19
      },
      fireBehavior: {
        output: 'schwerentflammbar (B1)',
        value: 'B1'
      },
      fireResistanceOuter: {
        output: 'F 90-B',
        value: 'F-90-B'
      },
      fireResistanceInner: {
        output: 'F 90-B',
        value: 'F-90-B'
      }
    },
    name: 'Wandaufbau mit Mineralwolle l Aufbau 11',
    construction: {
      composition: [
        {
          output: 'organischer Unterputz',
          type: 'render',
          title: { de: 'Putz' },
          value: 'org-1'
        },
        {
          output: '60 mm Sto-Speedlamelle Typ ll',
          type: 'pinsulation',
          title: { de: 'Dämmung' },
          value: 'msp-60'
        },
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'outerPlanking',
          title: { de: 'Beplankung Außen' },
          value: 'opg-12'
        },
        {
          output: '60/140',
          type: 'stand',
          title: { de: 'Ständer' },
          value: 'stae-140'
        },
        {
          output: '140 mm Glaswolle',
          type: 'compartmentInsulation',
          title: { de: 'Gefachdämmung' },
          value: 'cigw-140'
        },
        {
          output: '15 mm Gipsfaserplatte',
          type: 'innerPlanking1',
          title: { de: 'Beplankung Innen 1. Lage' },
          value: 'ig-15'
        },
        {
          output: '15 mm Gipsfaserplatte',
          type: 'innerPlanking2',
          title: { de: 'Beplankung Innen 2. Lage' },
          value: 'ip-15'
        }, 
        {
          output: 'keine',
          type: 'innerPlanking3',
          title: { de: 'Beplankung Innen 3. Lage' },
          value: null
        }
      ],
      sum: {
        output: '249',
        value: 249
      }
    }
  }
}
